import React from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { GenerateExpressionTestIds } from './GenerateExpression.testIds';

const AssumptionItem = ({ message }) => (
  <li>
    <Typography
      color="warning.dark"
      data-testid={GenerateExpressionTestIds.MODAL_ASSUMPTION_ITEM}
      variant="regular14"
    >
      {message}
    </Typography>
  </li>
);

AssumptionItem.propTypes = {
  message: PropTypes.string.isRequired,
};

export default AssumptionItem;
